module.exports = __webpack_public_path__ + "img/bg.6efc765c.png";